import { useEffect, useState } from 'react';
import { SmartForm } from '../../components/formFields/Form'
import { TextField } from '../../components/formFields/TextField';
import { Paciente } from '../../pagesApp/loginApp.types';
import { api } from '../../data/api';
import { useParams } from 'react-router-dom';
import { provinciasArray } from '../../pagesApp/Perfil.app';


const entityConstants = {
	apiEndpoint: '/api/pacientes',
	navigateToParent: '/paciente/pacientes'
}

const emptyHandler = (e: React.FormEvent<HTMLFormElement>) => {
	e.preventDefault();
}

export const PacientePage = () => {
	const { dni } = useParams();
	const [formData, setFormData] = useState<Partial<Paciente>>({
		dni: '',
		nombre: '',
		apellido: '',
		email: '',
		telefono: '',
		prepaga: '',
		afiliadoNro: '',
		direccion: '',
		ciudad: '',
		provincia: 0,
		codpostal: '',
	})

	useEffect(() => {
		if (dni) {
			const loadData = async () => {
				const {data} = await api.get<Paciente>(`${entityConstants.apiEndpoint}/${dni}`);
				setFormData(data);
			}
			loadData();
		}
	}, [dni]);

	return (
		<SmartForm
			title={'Paciente'}
			// onSubmit={emptyHandler}
			// cancelButtonNavigateTo={entityConstants.navigateToParent}
			// confirmButtonLabel={'Guardar'}
		>
			<TextField
				label='DNI'
				value={formData.dni || ''}
				disabled={true}
			/>
			<TextField
				label='Nombre'
				value={formData.nombre || ''}
				disabled={true}
			/>
			<TextField
				label='Apellido'
				value={formData.apellido || ''}
				disabled={true}
			/>
			<TextField
				label='Email'
				value={formData.email || ''}
				disabled={true}
			/>
			<TextField
				label='Teléfono'
				value={formData.telefono || ''}
				disabled={true}
			/>
			<TextField
				label='Obra Social'
				value={formData.prepaga || ''}
				disabled={true}
			/>
			<TextField
				label='Nro de Afiliado'
				value={formData.afiliadoNro || ''}
				disabled={true}
			/>
			<TextField
				label='Dirección'
				value={formData.direccion || ''}
				disabled={true}
			/>
			<TextField
				label='Ciudad'
				value={formData.ciudad || ''}
				disabled={true}
			/>
			<TextField
				label='Provincia'
				value={provinciasArray[(formData.provincia || 1) - 1]}
				disabled={true}
			/>
			<TextField
				label='Código Postal'
				value={formData.codpostal || ''}
				disabled={true}
			/>
		</SmartForm>
	)
}